<template>
    <div>
        <slot name="section"></slot>
        <b-card no-body>
            <b-tabs card v-model="tabIdx">
                <b-tab title="Address" active>
                    <b-card-body>
                        <b-form @submit.stop.prevent="onSubmit">
                            <b-form-row>
                                <b-col
                                    v-for="(d_item, i) in dataItems"
                                    :key="i + 'data'"
                                    cols="6"
                                >
                                    <b-form-group
                                        v-if="
                                            !(
                                                (d_item.field === 'name' ||
                                                    d_item.field ===
                                                        'is_warehouse') &&
                                                sectionOnly
                                            )
                                        "
                                        :id="d_item.field"
                                        :label="capitalCase(d_item.field)"
                                        :label-for="'input-' + d_item.field"
                                    >
                                        <b-form-input
                                            v-if="d_item.type === 'text'"
                                            :id="'input-' + d_item.field"
                                            v-model="model[d_item.field]"
                                            :required="d_item.required"
                                            :readonly="
                                                !!d_item.readonly || isReadOnly
                                            "
                                            trim
                                        ></b-form-input>
                                        <b-form-select
                                            v-if="d_item.type === 'select'"
                                            :disabled="isReadOnly"
                                            :id="'input-' + d_item.field"
                                            v-model="model[d_item.field]"
                                            :required="d_item.required"
                                            :options="getData(d_item.field)"
                                        ></b-form-select>
                                        <b-form-checkbox
                                            v-if="
                                                d_item.type === 'check' &&
                                                !sectionOnly
                                            "
                                            :id="'input-' + d_item.field"
                                            :readonly="isReadOnly"
                                            v-model="model[d_item.field]"
                                            :name="'input-' + d_item.field"
                                            :value="1"
                                            :unchecked-value="0"
                                        >
                                        </b-form-checkbox>
                                    </b-form-group>
                                </b-col>
                            </b-form-row>

                            <b-form-row>
                                <b-col>
                                    <b-button
                                        v-if="!hideControls"
                                        variant="secondary"
                                        :disabled="!!loading"
                                        @click="$router.go(-1)"
                                        >Cancel</b-button
                                    >

                                    <b-button
                                        v-if="!hideControls"
                                        type="submit"
                                        variant="primary"
                                        :disabled="!!loading"
                                        >{{
                                            loading
                                                ? 'Saving Changes...'
                                                : 'Save Changes'
                                        }}</b-button
                                    >
                                    <b-button
                                        v-if="!hideControls && this.model.id"
                                        @click="deleteLocation()"
                                        class="mr-2"
                                        variant="warning"
                                    >
                                        Delete Location
                                    </b-button>
                                    <slot v-bind:default="model"></slot>
                                </b-col>
                            </b-form-row>
                        </b-form>
                    </b-card-body>
                </b-tab>
                <b-tab title="Map">
                    <b-card-body>
                        <location-picker
                            v-if="tabIdx == 1"
                            title="Map Location"
                            :location="mapLocation"
                            @set-location="setCoordinates($event)"
                        />
                    </b-card-body>
                </b-tab>
                <b-tab title="Sections" v-if="!sectionOnly && !!model.id">
                    <b-card-body>
                        <b-form inline>
                            <label class="sr-only" for="inline-form-input-name"
                                >Section Name</label
                            >
                            <b-form-input
                                size="sm"
                                id="inline-form-input-name"
                                class="mb-2 mr-sm-2 mb-sm-0"
                                placeholder="Section Name"
                                v-model="section.name"
                            ></b-form-input>

                            <b-button
                                size="sm"
                                variant="primary"
                                @click="saveSection(section)"
                                >Add Section</b-button
                            >
                        </b-form>

                        <b-table
                            :fields="sectionFields"
                            striped
                            hover
                            :items="modelSections"
                        >
                            <template #cell(name)="data">
                                <b-form-input
                                    v-model="data.item.name"
                                ></b-form-input>
                            </template>
                            <template #cell(id)="row">
                                <b-button
                                    size="sm"
                                    @click="saveSection(row.item)"
                                    class="mr-2"
                                    variant="primary"
                                >
                                    Save
                                </b-button>

                                <b-button
                                    size="sm"
                                    @click="deleteSection(row.item.id)"
                                    class="mr-2"
                                    variant="warning"
                                >
                                    Delete
                                </b-button>
                            </template>
                        </b-table>
                    </b-card-body>
                </b-tab>
            </b-tabs>
        </b-card>
    </div>
</template>
<script>
import { debounce } from 'lodash'
import popupMixins from '@/mixins/popupMixins'
import LocationPicker from '@/components/Map/LocationPicker'

const dataItems = [
    { field: 'name', type: 'text', required: true },
    { field: 'is_warehouse', type: 'check' },
    { field: 'address1', type: 'text', required: true },
    { field: 'address2', type: 'text' },
    { field: 'city', type: 'text', required: true },
    { field: 'postal_code', type: 'text' },
    { field: 'country_code', type: 'select', required: true },
    { field: 'map_reference', type: 'text' },
    { field: 'latitude', type: 'text', readonly: true },
    { field: 'longitude', type: 'text', readonly: true },
]
/* 
const locationFields = [
    'address1',
    'address2',
    'city',
    'postal_code',
    'country_code',
] */

const generateEmptyForm = () => {
    return dataItems.reduce(
        (_form, item) => {
            const regexp = /^[a-zA-Z0-9-_]+$/
            if (typeof item === 'string' && item.match(regexp))
                _form[item] = null
            return _form
        },
        { id: 0 }
    )
}

const L = window.L
const model = generateEmptyForm()
/////default
model.latitude = 18.002804952844535
model.longitude = -76.78970255393327
model.country_code = 'JM'

export default {
    name: 'viewLocation',
    components: { LocationPicker },
    data() {
        return {
            tabIdx: 0,
            model,
            hasErrors: false,
            section: { name: null },
            modelSections: [],
            sectionFields: [
                'name',
                {
                    key: 'id',
                    label: 'Controls',
                },
            ],
        }
    },
    props: ['id', 'sectionOnly', 'loading', 'hideControls'],
    mixins: [popupMixins],
    computed: {
        isReadOnly() {
            return !!(this.sectionOnly && this.model.id)
        },
        dataItems() {
            return dataItems.filter(
                x =>
                    !(
                        (x.field === 'name' || x.field === 'is_warehouse') &&
                        this.sectionOnly
                    )
            )
        },
        title() {
            return this.model.id ? 'Edit Location' : 'Add Location'
        },
        sections() {
            return this.$store.getters['locations/sections']
        },

        simpleLocation() {
            return this.$store.getters['locations/simpleLocation']
        },
        mapLocation() {
            // addressLocation: L.latLng(18.002804952844535, -76.78970255393327),
            const _location = { ...(this.model || {}) }
            _location.lat = _location.latitude || 18.002804952844535
            _location.long = _location.longitude || -76.78970255393327
            _location.center = new L.latLng(_location.lat, _location.long)
            return _location
        },
    },
    watch: {
        sections: {
            handler: function (_sections) {
                //  Empty the array
                this.modelSections.splice(0)

                // Populate the model/state for the array
                for (let section of _sections) {
                    this.modelSections.push(section)
                }
            },
            deep: true,
        },
        simpleLocation: {
            handler: function (_location) {
                this.model = { ..._location }
                console.log('watched simpleLocation-', _location)
            },
            deep: true,
        },
        model: {
            handler: debounce(function (_data) {
                this.$emit('update-location-model', _data)
                this.fetchCoordinates()
            }, 800),
            deep: true,
        },
        /*  'model.address1': debounce(function () {
            this.fetchCoordinates()
        }, 800),
        'model.address2': debounce(function () {
            this.fetchCoordinates()
        }, 800),
        'model.city': debounce(function () {
            this.fetchCoordinates()
        }, 800),
        'model.country_code': debounce(function () {
            this.fetchCoordinates()
        }, 800),
        'model.postal_code': debounce(function () {
            this.fetchCoordinates()
        }, 800), // */
        id: function (id) {
            this.setLocation(id).then()
        },
    },

    async mounted() {
        this.model = generateEmptyForm()
        console.log('this.model', this.model)
        this.modelSections = []
        //const { id } = this
        //console.log('id', id)
        await this.setLocation(this.id)
    },
    methods: {
        async setLocation(id) {
            if (id) {
                try {
                    await this.$store.dispatch('locations/fetchById', id)
                    await this.$nextTick()
                    console.log(
                        'mounted-----simpleLocation',
                        this.simpleLocation
                    )
                    this.model = { ...this.simpleLocation }
                    this.modelSections = [...this.sections]
                } catch (error) {
                    console.error(error)
                    this.isError = true
                }
            }
        },
        setCoordinates({ lat: latitude, long: longitude }) {
            if (!this.isReadOnly) {
                this.model.latitude = latitude
                this.model.longitude = longitude
            }
        },

        fetchCoordinates() {
            if (!this.isReadOnly) {
                const $this = this
                this.$nextTick(() => {
                    const { address1, country_code } = $this.model
                    if (address1 && country_code) {
                        this.$store
                            .dispatch('locations/geocodeAddress', $this.model)
                            .then(({ latitude, longitude }) => {
                                $this.model.latitude = latitude
                                $this.model.longitude = longitude
                            })
                    }
                })
            }
        },

        capitalCase(data) {
            if (data == 'country_code') return 'Country'
            const list = data.split('_')
            if (list[list.length - 1] === 'id') {
                list.pop()
            }
            return list
                .map(
                    x => x.slice(0, 1).toUpperCase() + x.slice(1).toLowerCase()
                )
                .join('  ')
        },
        getData(field) {
            return (() => {
                switch (field) {
                    case 'country_code':
                        return [{ value: 'JM', text: 'Jamaica' }]
                }
            })()
        },

        deleteLocation() {
            console.log('Attempt to delete')
            const model = { ...this.model }
            this.$emit('delete-location', model.id)
        },
        async onSubmit() {
            const model = { ...this.model }

            if (!model.latitude || !model.longitude) {
                this.doToast(
                    'Error!',
                    "Latitude and Longitude missing. Please enter a valid address then click 'find address' on the Map",
                    'danger'
                )
                return
            }

            if (this.sectionOnly && !model.id) {
                model.name = model.name || Date.now().toString(36)
                model.is_warehouse = false
            }
            model.is_warehouse = !!model.is_warehouse
            const valid = await this.$validator.validate()

            console.log('valid', valid)
            if (!valid) {
                this.doToast('Error!', 'Entry not Valid', 'danger')
                return
            }
            if (valid) {
                this.$emit('save-location', model)
            }
        },

        /**
         *  Stores the section data
         */
        saveSection(section) {
            const location_id = this.simpleLocation.id
            this.$emit('save-section', { section, location_id })
        },
        deleteSection(id) {
            const location_id = this.simpleLocation.id
            this.$emit('delete-section', { id, location_id })
        },
    },
}
</script>
<style></style>
